export const formatToProgressValue = (value?: string | number) => {
  if (typeof value === 'undefined' || isNaN(value as number)) {
    return undefined;
  }

  return Number(value);
};
